import { Timer } from "@phosphor-icons/react";
import { EmptyState } from "../shared/EmptyState";

// Compact PRIMARY hero for the First 5 O/U projection -- promoted to sit right below the Full
// Game O/U hero per the page reorg. Uses the exact same f5_total values already returned by the
// prediction endpoint (no new calculation); the full component/audit breakdown still lives in
// the "First 5 Innings Details" collapsible below.
export const F5OUHeroCard = ({ f5Total, testId }) => {
  if (!f5Total) {
    return (
      <div data-testid={testId} className="flex flex-col gap-3">
        <EmptyState icon={Timer} title="First 5 O/U Unavailable" description="Loading prediction data." testId={`${testId}-empty`} />
      </div>
    );
  }

  const ok = f5Total.status === "ok";
  const market = f5Total.market_line;

  return (
    <div data-testid={testId} className="flex flex-col gap-3">
      {ok ? (
        <>
          <div className="rounded-lg border border-white/10 bg-eb-bg p-4 text-center">
            <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">EdgeBall Projected Total Runs</span>
            <p data-testid={`${testId}-projected-total`} className="mt-1 font-heading text-3xl text-white">
              {f5Total.projected_f5_total.toFixed(2)}
            </p>
          </div>

          <div data-testid={`${testId}-market`} className="rounded-lg border border-white/10 bg-eb-bg p-3">
            <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">F5 Market Total</span>
            {market ? (
              <p className="mt-1 font-mono text-sm text-zinc-200">
                {market.line_value} <span className="text-zinc-500">({market.sportsbook})</span>
              </p>
            ) : (
              <p data-testid={`${testId}-market-unavailable`} className="mt-1 font-mono text-sm text-zinc-500">
                F5 market line unavailable
              </p>
            )}
          </div>

          {f5Total.threshold_status === "ok" ? (
            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-lg border border-white/10 bg-eb-bg p-3 text-center">
                <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Over {f5Total.f5_total_threshold}</span>
                <p data-testid={`${testId}-over-probability`} className="mt-1 font-heading text-xl text-white">
                  {(f5Total.over_probability * 100).toFixed(1)}%
                </p>
              </div>
              <div className="rounded-lg border border-white/10 bg-eb-bg p-3 text-center">
                <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Under {f5Total.f5_total_threshold}</span>
                <p data-testid={`${testId}-under-probability`} className="mt-1 font-heading text-xl text-white">
                  {(f5Total.under_probability * 100).toFixed(1)}%
                </p>
              </div>
            </div>
          ) : (
            <p data-testid={`${testId}-no-threshold`} className="font-mono text-xs text-zinc-400">
              No F5 market line synced yet, so no Over/Under probability is shown.
            </p>
          )}

          <p data-testid={`${testId}-disclaimer`} className="font-mono text-[10px] text-zinc-500">
            Starter-focused analytical projection. Bullpen excluded.
          </p>
        </>
      ) : (
        <EmptyState icon={Timer} title="Insufficient Data For F5 O/U" description={f5Total.reason || "Not enough first-5-innings data yet."} testId={`${testId}-insufficient`} />
      )}
    </div>
  );
};
